import { Component, computed, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { COMMON_IMPORTS } from '../../../../../../Shared/common-imports';
import { LicenceAssignDialogData } from '../../../../../Interfaces/licence-assign-dialog.interface';

@Component({
    selector: 'app-licence-assign-dialog',
    standalone: true,
    imports: [COMMON_IMPORTS],
    templateUrl: './licence-assign-dialog.component.html',
    styleUrls: ['../../../billing/billing.scss'],
})
export class LicenceAssignDialogComponent {
    readonly data = inject<LicenceAssignDialogData>(MAT_DIALOG_DATA);
    private readonly _dialogRef = inject(MatDialogRef<LicenceAssignDialogComponent, string>);

    readonly selectedUserId = signal<string | null>(null);

    readonly isEmpty = computed<boolean>(() => this.data.users.length === 0);

    readonly pendingCancellationAt = computed<string | null>(() => this.data.licence.cancels_at);

    readonly isConfirmDisabled = computed<boolean>(() => !this.selectedUserId());

    selectUser(userId: string): void {
        this.selectedUserId.set(userId);
    }

    confirm(): void {
        const userId = this.selectedUserId();

        if (!userId) {
            return;
        }

        this._dialogRef.close(userId);
    }

    close(): void {
        this._dialogRef.close();
    }
}
